import http from './http.service';

class VehicleService {
    constructor() {
        if (VehicleService.instance) {
            return VehicleService.instance;
        }

        VehicleService.instance = this;
    }

    vehicles() {
        return http.get('/vehicle').then(res => res.data);
    }
    noEmpties() {
        return http.get('/vehicle/no-empties').then(res => res.data);
    }
    store(data) {
        return http.post('/vehicle/store', data).then(res => res.data);
    }
    show(vehicleId) {
        return http.get(`/vehicle/${vehicleId}/show`).then(res => res.data);
    }
    update(vehicleId, data) {
        return http.put(`/vehicle/${vehicleId}/update`, data).then(res => res.data);
    }
    updateDiscountDates(vehicleId, data) {
        return http.put(`/vehicle/${vehicleId}/update-discount-dates`, data).then(res => res.data);
    }
    toggleActive(vehicleId) {
        return http.put(`/vehicle/${vehicleId}/toggle-active`).then(res => res.data);
    }
    reorder(vehicles) {
        return http.put('/vehicle/reorder', vehicles).then(res => res.data);
    }
    destroy(vehicleId) {
        return http.delete(`/vehicle/${vehicleId}/destroy`).then(res => res.data);
    }
    destroyImg(imgId) {
        return http.delete(`/vehicle/img/${imgId}/destroy`).then(res => res.data);
    }

    // settings

    makes() {
        return http.get('/settings/makes').then(res => res.data);
    }
    models(makeId) {
        return http.get(`/settings/${makeId}/models`).then(res => res.data);
    }
    params() {
        return http.get('/settings/params').then(res => res.data);
    }
}

export default new VehicleService();
